import { motion } from 'framer-motion';

import { cn } from 'lib/utils';

interface ProfileTabButtonProps {
  onClick: () => void;
  isSelected: boolean;
  label: string;
}

export default function ProfileTabButton({
  onClick,
  isSelected,
  label,
}: ProfileTabButtonProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'transition-colors text-sm rounded-sm relative w-fit px-2 py-1',
        isSelected ? 'text-gray-900 font-medium' : 'text-white'
      )}
    >
      <span className='relative z-10'>{label}</span>
      {isSelected && (
        <motion.span
          layoutId='pill-tab'
          transition={{ type: 'spring', duration: 0.5 }}
          className='absolute inset-0 z-0 bg-white rounded-sm'
        />
      )}
    </button>
  );
}
